import { useState } from "react";

import ConsultationList from "./ConsultationList/ConsultationList";
import ConsultationDetail from "./ConsultationDetail/ConsultationDetail";

import { useAuth } from "../../../Context/AuthContext";
import { fetchConsultationDetailed } from "../../../Api/Backend/Consultation";


function Consultation({}) {
    const auth = useAuth();

    const [isListView, setIsListView] = useState(true); 
    const [detailedData, setDetailedData] = useState(null);

    const handleListItemClick = async (item) => {
        if (!item?.consultationId) {
            alert("Clicked item returned no consultationId");
            return;
        }
        setDetailedData(null);

        await fetchConsultationDetailed({
            auth: auth,
            consultationId: item.consultationId,
            onSuccess: (data) => {
                setDetailedData(data)
                setIsListView(false);
            },
            onError: (error) => {
                console.error("Error fetching detailed user data:", error);
            }
        });
    };

    const handleBackClick = () => {
        setIsListView(true);
        setDetailedData(null);
    };

    return (
        <>
            {isListView ? (
                <ConsultationList onItemClickHandle={handleListItemClick} />
            ) : (
                <ConsultationDetail data={detailedData} onBackClick={handleBackClick}/>
            )}
        </>
    );

}

export default Consultation;